/*eslint-disable*/
import React from 'react'
import { Form as Formiker, Field as Fieldmik, Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment'
import { Form as FormUi, Button, Segment, Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux'

import DocumentTable from './documentTable';
import VehicleDropDown from './vehicleDropDown'
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';


import { createDocument, uploadDocument, checkVehicle } from '../../redux/actions/documentActions'



function InsertDocument(props){

    const { vehicleData, selectVehicleId, checkVehicle, documentList, createDocument, uploadDocument, docLoading, vehicleStatus } = props

    

    function vehicleType(){
        console.log("Vehicle Data and Select Vehicle Id", vehicleData, selectVehicleId)
       
        if ( vehicleData && selectVehicleId ){

            console.log("Vehicle Data and Select Vehicle Id", vehicleData, selectVehicleId)

            const vehicleSelected = vehicleData.filter((item) => {
                if(item.vehicleMasterId === selectVehicleId && item.vehicleType){
                    return item.vehicleType
                } else {
                    return null
                }   
            })

            
            const getVehicleType = vehicleSelected && vehicleSelected[0].vehicleType ? vehicleSelected[0].vehicleType : null
            console.log("Data Vehicle Type", getVehicleType)
            return getVehicleType
        }
    }

    function vehicleBranch(){
        if ( vehicleData && selectVehicleId ){
            const vehicleSelected = vehicleData.filter((item) => {
                if(item.vehicleMasterId === selectVehicleId && item.vehicleType){
                    return item
                } else {
                    return null
                }
            })

            console.log("Data Vehicle Type ====>", vehicleSelected)
            const getVehicleBranch = vehicleSelected && vehicleSelected[0].branchName ? vehicleSelected[0].branchName : null
            return getVehicleBranch
        }
    }

    const vehicleTypeText = vehicleType()
    const vehicleBranchText = vehicleBranch()

    const initDocs = []

    documentList && documentList.map((object, index) => {
        let temp = {}
        temp.docTypeName = object.documentTypeName
        temp.startDate = ''
        temp.expiryDate = ''
        temp.vehicleId = ''
        temp.vehicleNo = ''
        temp.fileUpload = '' 
        initDocs[index] = temp
    })

    console.log("Init Docs ", initDocs)

    const initialValues = {
        "vehicleId": '',
        "vehicleNo": '',
        "vehicleBranch": vehicleBranchText ? vehicleBranchText : '',
        "vehicleType": vehicleTypeText ? vehicleTypeText : '',
        "docsData": initDocs,
        
    }
    
    const onUpload = (values, index) => {
        const uploadData = {};
        uploadData.vehicleId = selectVehicleId
        uploadData.vehicleNo = values.vehicleNo
        uploadData.docTypeName = documentList[index].documentTypeName
        uploadData.docId = documentList[index].documentTypeId
        uploadData.docFile = values.docsData[index].fileUpload.base64.split(',')[1]
        uploadDocument(uploadData)
    }

    const validationSchema = yup.object({
        vehicleId: yup.string().required(' Required'),
    })
    

    const onSubmit = values => {
        console.log("Form Data: ", values);
        console.log("Form Props: ", props);
        const uploadData = []
        values.docsData.map((object, index) => {    
            let temp = {}
            temp.vehicleId = selectVehicleId
            temp.vehicleNo = values.vehicleNo
            temp.docTypeName = documentList[index].documentTypeName
            temp.docId = documentList[index].documentTypeId
            temp.docVehicleMapId = 0
            temp.startDate =  object === undefined ? '' : object.startDate === '' ? '' : moment(object.startDate).format('DD-MM-YYYY')
            temp.expiryDate = object === undefined ? '' : object.expiryDate === '' ? '' : moment(object.expiryDate).format('DD-MM-YYYY')
            temp.fileUpload = ''
            uploadData[index] = temp  
        })
    
        console.log("==> Upload Data",uploadData)
        createDocument(uploadData)
    }

    if(docLoading){
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    }else{
        return (
            <React.Fragment>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, isSubmitting, errors, touched }) => (
                        <Formiker className="m-2">
                            
                        <Segment>
                            <div className="ui form">
                                
                                <FormUi.Group inline>
                                    <FormUi.Field >
                                        <label className="labelName w3-text-blue">Basic Details</label>
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group inline>
                                    <FormUi.Field width={3}>
                                        <label className="labelName">Vehicle Number*</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik 
                                            autoComplete="off"
                                            component={VehicleDropDown}
                                            name="vehicleId"   
                                            placeholder="Vehicle No."
                                            vehicleNoName='vehicleNo'
                                        />
                                        {touched.vehicleId && errors.vehicleId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleId}</div> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width={1} />
                                    <FormUi.Field width={3}>
                                        <label className="labelName">Vehicle Type</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik 
                                            name="vehicleType" 
                                            placeholder="Type"
                                            autoComplete="off"
                                            readOnly
                                            value={vehicleTypeText} />
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group inline>
                                    <FormUi.Field width={3}>
                                        <label className="labelName">Branch</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={3}>
                                        <Fieldmik 
                                            name="vehicleBranch" 
                                            placeholder="Branch"
                                            readOnly
                                            autoComplete="off"
                                            value={vehicleBranchText} />
                                    </FormUi.Field>
                                </FormUi.Group>
                            </div>
                        </Segment>
                      
                        <div className="ui form">
                            <DocumentTable onUpload={onUpload} docLoading={docLoading} />
                        </div>
                        {console.log("vehicle status", vehicleStatus)}
                        <center className="m-3"><Button disabled={vehicleStatus === 0 ? false : true} size="mini" type="submit" primary>Submit</Button></center>
                    </Formiker>
    
                    ) }
                                
                </Formik>
                
            </React.Fragment>
        )
    }    
}


const mapStatetoProps = (state) => ({
    vehicleData: state.getVehicleNo.vehicleNo.resultSet,
    selectVehicleId: state.selectVehicleId.selectVehicleId,
    documentList: state.getDocumentList.documentList.resultSet,
    docLoading: state.getDocumentList.isLoading,
    vehicleStatus: state.checkVehicle.checkVehicle.status
})

export default connect(mapStatetoProps, { createDocument, uploadDocument, checkVehicle  })(InsertDocument);